/*
 * Fragrance Central Hub — native wishlist (device-local, no app, no backend).
 * Stores product handles in localStorage. Injects heart buttons on product
 * cards + PDP, keeps a header count badge, and renders the /pages/wishlist page
 * by fetching live product JSON. Replaces Wishlist Hero (~114 KB) at ~4 KB.
 */
(function () {
  'use strict';
  var KEY = 'fch:wishlist:v1';
  var CUR = ' USD';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function has(h) { return read().indexOf(h) > -1; }

  function toggle(h) {
    var l = read(), i = l.indexOf(h), added = false;
    if (i > -1) { l.splice(i, 1); } else { l.push(h); added = true; }
    write(l);
    sync();
    badge();
    if (document.getElementById('fch-wl-grid')) renderPage();
    return added;
  }

  var HEART = '<svg class="fch-wish-ic" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">' +
    '<path d="M12 20.6l-1.5-1.4C5.1 14.4 2 11.5 2 7.9 2 5 4.2 2.8 7 2.8c1.6 0 3.1.7 4 1.9.9-1.2 2.4-1.9 4-1.9 2.8 0 5 2.2 5 5.1 0 3.6-3.1 6.5-8.5 11.3L12 20.6z"/></svg>';

  function badge() {
    var n = read().length;
    document.querySelectorAll('.fch-wish-badge').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
  }

  function sync() {
    var l = read();
    document.querySelectorAll('.fch-wish-btn').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-fch-wish')) > -1;
      b.classList.toggle('is-wished', on);
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = b.querySelector('.fch-wish-btn__label');
      if (lbl) lbl.textContent = on ? 'In your wishlist' : 'Add to wishlist';
    });
  }

  function makeBtn(h, variant) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fch-wish-btn' + (variant ? ' fch-wish-btn--' + variant : '');
    b.setAttribute('data-fch-wish', h);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART + (variant === 'pdp' ? '<span class="fch-wish-btn__label"></span>' : '');
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle(h);
    });
    return b;
  }

  function handleFrom(a) {
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/\/products\/([a-z0-9][a-z0-9\-]*)/i);
    return m ? m[1] : null;
  }

  function injectCards(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.fch-wish-btn')) return;
      var h = handleFrom(card.querySelector('a[href*="/products/"]'));
      if (!h) return;
      var host = card.querySelector('.card__inner') || card.querySelector('.card__media') || card;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(makeBtn(h, 'card'));
    });
    sync();
  }

  function injectPDP() {
    var m = location.pathname.match(/\/products\/([a-z0-9][a-z0-9\-]*)/i);
    if (!m) return;
    var anchor = document.querySelector('.product-form__buttons');
    if (!anchor) return;
    var parent = anchor.parentNode;
    if (parent.querySelector('.fch-wish-btn--pdp')) return;
    parent.insertBefore(makeBtn(m[1], 'pdp'), anchor.nextSibling);
    sync();
  }

  function sized(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + v + CUR;
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderPage() {
    var grid = document.getElementById('fch-wl-grid');
    if (!grid) return;
    var empty = document.getElementById('fch-wl-empty');
    var list = read();
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    list.forEach(function (h) {
      fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var img = sized(p.featured_image || (p.images && p.images[0]) || '', 500);
          var price = money(p.price);
          if (p.compare_at_price && p.compare_at_price > p.price) {
            price = '<span class="fch-wl-was">' + money(p.compare_at_price) + '</span> ' + money(p.price);
          }
          var el = document.createElement('div');
          el.className = 'fch-wl-card';
          el.innerHTML =
            '<button type="button" class="fch-wl-remove" data-fch-wish="' + esc(h) + '" aria-label="Remove from wishlist">&times;</button>' +
            '<a class="fch-wl-media" href="' + esc(p.url) + '">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(p.title) + '">' : '') + '</a>' +
            '<div class="fch-wl-info">' +
            (p.vendor ? '<div class="fch-wl-vendor">' + esc(p.vendor) + '</div>' : '') +
            '<a class="fch-wl-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="fch-wl-price">' + price + '</div>' +
            '<a class="fch-wl-cta" href="' + esc(p.url) + '">View product</a>' +
            '</div>';
          el.querySelector('.fch-wl-remove').addEventListener('click', function () { toggle(h); });
          grid.appendChild(el);
        })
        .catch(function () {});
    });
  }

  var t;
  function debouncedCards() { clearTimeout(t); t = setTimeout(function () { injectCards(); }, 200); }

  function init() {
    injectCards();
    injectPDP();
    badge();
    renderPage();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { debouncedCards(); return; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    // keep count in sync if another tab changes it
    window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); badge(); if (document.getElementById('fch-wl-grid')) renderPage(); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
